var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.row.executionStatusCode !== 0 && _vm.row.errordata === 'Error')?_c('b-row',[_c('a',{on:{"click":_vm.showDialog}},[_vm._v("Exception")])]):_c('b-row')}
var staticRenderFns = []

export { render, staticRenderFns }